import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelfHosted } from '../lib/instanceLicence';

// Billing and Self-hosted belong to our cloud. On a self-hosted install the
// licence is managed from the customer's cloud account, so these routes lead
// back to the dashboard.
export default function CloudOnly({ children }) {
  const selfHosted = useSelfHosted();
  if (selfHosted) return <Navigate to="/dashboard" replace />;
  return children;
}
